import { Type } from "@sinclair/typebox";
import { NonEmptyString } from "./primitives.js";

export const SessionPreviewRegisterParamsSchema = Type.Object(
  {
    sessionKey: NonEmptyString,
    containerPort: Type.Integer({ minimum: 3000, maximum: 9999 }),
    label: Type.Optional(Type.String()),
    publicOrigin: Type.Optional(Type.String()),
    rotateToken: Type.Optional(Type.Boolean()),
  },
  { additionalProperties: false },
);

export const SessionPreviewRegisterResultSchema = Type.Object(
  {
    sessionKey: NonEmptyString,
    sessionSlug: NonEmptyString,
    containerPort: Type.Integer({ minimum: 3000, maximum: 9999 }),
    label: Type.Union([Type.String(), Type.Null()]),
    token: NonEmptyString,
    previewUrl: NonEmptyString,
    containerName: NonEmptyString,
  },
  { additionalProperties: false },
);

export const SessionPreviewClearParamsSchema = Type.Object(
  {
    sessionKey: NonEmptyString,
  },
  { additionalProperties: false },
);

export const SessionPreviewClearResultSchema = Type.Object(
  {
    sessionKey: NonEmptyString,
    cleared: Type.Boolean(),
  },
  { additionalProperties: false },
);

export const SessionPreviewInfoSchema = Type.Object(
  {
    registered: Type.Boolean(),
    containerPort: Type.Union([Type.Integer({ minimum: 3000, maximum: 9999 }), Type.Null()]),
    label: Type.Union([Type.String(), Type.Null()]),
    sessionSlug: NonEmptyString,
    previewUrl: Type.Union([Type.String(), Type.Null()]),
    token: Type.Union([Type.String(), Type.Null()]),
    registeredAtMs: Type.Union([Type.Integer({ minimum: 0 }), Type.Null()]),
    expiresAtMs: Type.Union([Type.Integer({ minimum: 0 }), Type.Null()]),
  },
  { additionalProperties: false },
);
